/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum FormInitialisationParameterType {
  String = 'String',
  Boolean = 'Boolean',
  DateTime = 'DateTime',
  Enum = 'Enum',
  Select = 'Select',
  EntityId = 'EntityId',
  FileIndex = 'FileIndex'
}
